import React from 'react';
import { createSelectBoxClassName } from './selectBoxStyles';

type TProps = {
  title: string;
  description?: string;
  onClick(): void;
};

export const SelectBoxOption = ({ title, description, onClick }: TProps) => (
  <button
    type="button"
    className={createSelectBoxClassName('option')}
    onClick={onClick}
  >
    <div className={createSelectBoxClassName('title')}>{title}</div>
    {description && (
      <div className={createSelectBoxClassName('description')}>
        {description}
      </div>
    )}
  </button>
);
